export default new Promise(async (resolve, reject) => {
  if ('IntersectionObserver' in window) return resolve(window.IntersectionObserver);

  // force the polyfill to get split out into its own bundle (which forces asynchronicity)
  return import(/* webpackChunkName: "intersection-observer" */ 'intersection-observer')
    .then(() => resolve(window.IntersectionObserver))
    .catch(reject);
});
